import { Button } from "@/components/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

interface YearNavigatorProps {
  selectedYear: number;
  onYearChange: (year: number) => void;
  minYear: number;
  maxYear?: number;
  title: string;
}

const currentYear = new Date().getFullYear();

export default function YearNavigator({
  selectedYear,
  onYearChange,
  minYear,
  maxYear = currentYear,
  title,
}: YearNavigatorProps) {
  const handlePreviousYear = () => {
    if (selectedYear > minYear) {
      onYearChange(selectedYear - 1);
    }
  };

  const handleNextYear = () => {
    if (selectedYear < maxYear) {
      onYearChange(selectedYear + 1);
    }
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={handlePreviousYear}
          disabled={selectedYear <= minYear}
          className="h-6 w-6"
        >
          <ChevronLeftIcon className="h-4 w-4" />
        </Button>

        <span className="text-sm font-medium min-w-[120px] text-center">
          {title}: {selectedYear}
        </span>

        <Button
          variant="ghost"
          size="icon"
          onClick={handleNextYear}
          disabled={selectedYear >= maxYear}
          className="h-6 w-6"
        >
          <ChevronRightIcon className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}